module.exports = __webpack_public_path__ + "img/5e31afc.png";